var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'יש בעיה עם פרטי החשבונות.',"text":'אי אפשר לעדכן את התזרים כי חלק מפרטי החשבונות שאצלינו לא עובדים.',"notification-buttons":[
                      {
                        title:'לעדכון פרטים',
                        variant: 'primary',
                        action: _vm.goToCredentialsSettings,
                      } ],"icon-type":'danger'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }